<div class="p-6 w-[350px]">
  <h2 class="text-xl font-bold mb-4">Purgar viaje</h2>

  <!-- Visual toggle options conectados al form -->
  <form [formGroup]="form" (ngSubmit)="openCustomDialog()" class="space-y-4">
    <div class="grid gap-4 mb-4">
      <app-toggle-option
        title="Purgado parcial"
        description="Purgar únicamente los documentos en trabajo en curso (como Facturas, Documentos de Merma, etc.)."
        icon="tune"
        iconColor="blue"
        formControlName="partial"
        (valueChange)="onSelectPurge(TripPurgeTypeEnum.PARTIAL)">
      </app-toggle-option>

      <app-toggle-option
        title="Purgado total"
        description="Purgar los documentos tanto en trabajo en curso como los de entrega."
        icon="autorenew"
        iconColor="red"
        formControlName="total"
        (valueChange)="onSelectPurge(TripPurgeTypeEnum.TOTAL)">
      </app-toggle-option>
    </div>

    <div class="bg-red-100 border border-red-300 p-3 rounded text-sm text-red-700">
      ⚠️ Esta acción <strong>no se puede revertir</strong>.
    </div>

    <div class="flex justify-between gap-2 pt-4">
      <button type="button" (click)="onCancel()" class="px-4 py-2 text-sm bg-gray-200 rounded hover:bg-gray-300">
        Cancelar
      </button>
      <button type="submit" [disabled]="!isSomeOptionSelected"
        class="px-4 py-2 text-sm bg-red-600 text-white rounded hover:bg-red-700">
        Purgar viaje
      </button>
    </div>
  </form>
</div>

<ng-template #customAlert let-data>
  <div class="flex items-start space-x-2 mb-2">
    <div class="flex items-center">
      <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
        style="font-size: 32px"></mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmación de purga de viaje</h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>¿Está seguro de que desea purgar este viaje?</p>
        <div class="text-sm text-red-600">
          Esta acción es irreversible y eliminará información del viaje <br> según el tipo de purga seleccionado.
        </div>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="flex justify-between">
    <button mat-button mat-dialog-close class="align-left">
      Cancelar
    </button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">
      Aceptar
    </button>
  </mat-dialog-actions>
</ng-template>